import angular from 'angular';
import 'angular-ui-tree';
import faqViewTemplate from './faq.html';
import FaqManagementComponent from './components/faq-management/faq-management-component';
import FaqCategoryComponent from './components/faq-category/faq-category-component';
import FaqSearchComponent from './components/faq-search/faq-search-component';
import './config/errorcodes.conf';
import { changePageTitle } from 'auth/actions/session.actions';

const mapStateToThis = ({ session }) => {
  const { locale } = session;

  return {
    locale,
  };
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$state', 'gettextCatalog', 'Responsive')
class FaqViewController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
  }

  $onInit() {
    this.onLanguageSelect(this.locale);
    this.api.loadData.run(this.editMode);
  }

  $onDestroy() {
    this.unsubscribe();
  }

  acceptDndTree(sourceNodeScope, destNodesScope) {
    return this.api.accept(sourceNodeScope, destNodesScope);
  }

  onLanguageSelect(locale) {
    this.model[this.namespace][this.moduleName].language = locale;
  }
}

class FaqViewComponent {
  constructor() {
    this.template = faqViewTemplate;
    this.controller = FaqViewController;
    this.bindings = {
      appCtrl: '<',
      model: '<',
      editMode: '<',
      moduleName: '@',
      namespace: '@',
      api: '<',
    };
    return this;
  }
}

export default angular
  .module('faq', ['ui.router', 'ui.tree', 'faq-errorcodes'])
  .component('faq', new FaqViewComponent())
  .component('faqSearch', new FaqSearchComponent())
  .component('faqManagement', new FaqManagementComponent())
  .component('faqCategory', new FaqCategoryComponent())
  .config([
    '$stateProvider',
    function configure($stateProvider) {
      $stateProvider
        .state('faq-view', {
          parent: 'arw',
          url: '/faq',
          restKey: 'user',
          template: `<faq model="appCtrl.appFactory.model"
                         app-ctrl="appCtrl"
                         edit-mode="false"
                         module-name="faq"
                         namespace="faq"
                         api="$resolve.api"
                     ></faq>`,
          redirectTo: 'home-view',
          params: {
            pageTitle: [
              '$ngRedux',
              'gettextCatalog',
              ($ngRedux, gettextCatalog) => {
                $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Frequently Asked Questions')));
              },
            ],
          },
          resolve: {
            api: [
              'appFactory',
              'appApi',
              (appFactory) =>
                appFactory
                  .dispatch('faq.loadDictionaries', true)
                  .run()
                  .then(() => ({
                    config: appFactory.deps.config,
                    search: appFactory.dispatch('faq.search', true),
                    loadData: appFactory.dispatch('faq.loadData', true),
                  }))
                  .catch((err) => console.error(err)),
            ],
          },
        })
        .state('faq-admin', {
          parent: 'arw',
          url: '/faq-admin',
          restKey: 'admin',
          template: ` <faq model="appCtrl.appFactory.model"
                                    app-ctrl="appCtrl"
                                    edit-mode="true"
                                    module-name="faq"
                                    namespace="faq"
                                    api="$resolve.api"
                               ></faq>`,
          params: {
            pageTitle: [
              '$ngRedux',
              'gettextCatalog',
              ($ngRedux, gettextCatalog) => {
                $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Manage Frequently Asked Questions')));
              },
            ],
          },
          redirectTo: 'permissions-denied',
          resolve: {
            api: [
              'appFactory',
              'appApi',
              (appFactory) =>
                appFactory
                  .dispatch('faq.loadDictionaries', true)
                  .run()
                  .then(() => ({
                    config: appFactory.deps.config,
                    accept: appFactory.actions.faq.accept,
                    dropped: appFactory.dispatch('faq.dropped', true),
                    loadData: appFactory.dispatch('faq.loadData', true),
                    saveCategory: appFactory.dispatch('faq.saveCategory', true),
                    updateCategory: appFactory.dispatch('faq.updateCategory', true),
                    deleteCategory: appFactory.dispatch('faq.deleteCategory', true),
                    deleteEntry: appFactory.dispatch('faq.deleteEntry', true),
                    saveEntry: appFactory.dispatch('faq.saveEntry', true),
                    onLanguageSelect: appFactory.dispatch('app.toggleLanguageSelect', true),
                    faqDialogApi: {
                      config: appFactory.deps.config,
                      onLanguageSelect: appFactory.dispatch('app.toggleLanguageSelect', true),
                      initializeForm: appFactory.dispatch('app.initializeForm', true),
                      validateForm: appFactory.dispatch('app.validateForm', true),
                      setLanguageValidation: appFactory.actions.app.setLanguageValidation,
                    },
                  }))
                  .catch((err) => console.error(err)),
            ],
          },
          hideSidebar: false,
        })
        .state('faq-user', {
          parent: 'arw',
          url: '/faq-user',
          restKey: 'user',
          template: `<faq model="appCtrl.appFactory.model"
                                    edit-mode="false"
                                    module-name="faq"
                                    namespace="faq"
                                    api="$resolve.api"
                               ></faq>`,
          redirectTo: 'home-view',
          params: {
            pageTitle: [
              '$ngRedux',
              'gettextCatalog',
              ($ngRedux, gettextCatalog) => {
                $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Frequently Asked Questions')));
              },
            ],
          },
          resolve: {
            api: [
              'appFactory',
              'appApi',
              (appFactory) =>
                appFactory
                  .dispatch('faq.loadDictionaries', true)
                  .run()
                  .then(() => ({
                    config: appFactory.deps.config,
                    search: appFactory.dispatch('faq.search', true),
                    loadData: appFactory.dispatch('faq.loadData', true),
                  }))
                  .catch((err) => console.error(err)),
            ],
          },
          hideSidebar: false,
        });
    },
  ]);



// WEBPACK FOOTER //
// ./src/modules/faq/faq-component.js